/*
=======================================================================================================
  JavaScript Document
  Developed by NGUYEN TAN CUONG
  XOI Digital Development & Designs
  2011 - 2020
  CHARTS
=======================================================================================================
*/

const WHITE = '#ffffff';
const INDEPENDECE = '#43425D';

// Juan Mendes https://stackoverflow.com/a/3368118
const roundRect = (c, x, y, width, height, rad) => {
  let radius = rad;

  if (typeof radius === 'undefined') {
    radius = 5;
  }

  if (typeof radius === 'number') {
    radius = { tl: radius, tr: radius, br: radius, bl: radius };
  } else if (Array.isArray(radius)) {
    radius = {
      tl: radius[0] || 0,
      tr: radius[1] || 0,
      br: radius[2] || 0,
      bl: radius[3] || 0
    };
  } else {
    const defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };

    Object.keys(defaultRadius).forEach((side) => {
      radius[side] = radius[side] || defaultRadius[side];
    });
  }

  c.beginPath();
  c.moveTo(x + radius.tl, y);
  c.lineTo(x + width - radius.tr, y);
  c.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  c.lineTo(x + width, y + height - radius.br);
  c.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  c.lineTo(x + radius.bl, y + height);
  c.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  c.lineTo(x, y + radius.tl);
  c.quadraticCurveTo(x, y, x + radius.tl, y);
  c.closePath();
  c.fill();
};

const fillArc = (c, x, y, r, s, e) => {
  const sx = x + r * Math.cos(s);
  const sy = y + r * Math.sin(s);

  c.beginPath();
  c.moveTo(x, y);
  c.lineTo(sx, sy);
  c.arc(x, y, r, s, e);
  c.lineTo(x, y);
  c.closePath();

  c.fill();
};

function Chart(canvas, width, height) {
  this.canvas = canvas;
  this.chart = canvas.getContext('2d');

  this.canvas.width = width;
  this.canvas.height = height;

  this.xPadding = 50;
  this.yPadding = 100;
  this.series = [];
  this.labels = [];
  this.title = 'init';
  this.yStep = 20;
  this.xStep = 20;
  this.yMax = 100;
  this.yMin = 0;
  this.xMax = 100;
  this.xMin = 0;

  this.highlightedRange = [];

  this.color = '#848484';
  this.grayColor = '#333333';
}

Chart.prototype.getXMidOffset = function getXMidOffset() {
  const x0 = this.getXPos(0);
  const x1 = this.getXPos(1);

  return (x1 - x0) / 4;
};

Chart.prototype.getXPos = function getXPos(i) {
  return (((this.series[i].x - this.xMin) * (this.canvas.offsetWidth - this.xPadding * 1.5)) / (this.xMax - this.xMin)) + this.xPadding;
};

Chart.prototype.getYPos = function getYPos(i, j) {
  const val = !this.stacked ? this.series[i].y : this.series[i].y[j];
  return this.canvas.offsetHeight - (((this.canvas.offsetHeight - this.yPadding * 1.5) / (this.yMax - this.yMin)) * (val - this.yMin)) - this.yPadding;
};

Chart.prototype.getBarHeight = function getBarHeight(i, j) {
  const yPos = this.getYPos(i, j);
  return this.canvas.offsetHeight - yPos - this.yPadding;
};

Chart.prototype.getXAxisPos = function getXAxisPos(i) {
  return (((i - this.xMin) * (this.canvas.offsetWidth - this.xPadding * 1.5)) / (this.xMax - this.xMin)) + this.xPadding;
};

Chart.prototype.getYAxisPos = function getYAxisPos(i) {
  return this.canvas.offsetHeight - (((this.canvas.offsetHeight - this.yPadding * 1.5) / (this.yMax - this.yMin)) * (i - this.yMin)) - this.yPadding;
};

Chart.prototype.drawXAxisText = function drawXAxisText(i, grid) {
  const c = this.chart;

  const offsetX = this.stacked ? this.getXMidOffset() + (this.canvas.width / this.series.length / 4) : 0;
  const offsetY = 40;
  const posY = this.canvas.offsetHeight - this.yPadding;
  const posX = this.getXAxisPos(i);

  const label = this.labels[i] || i;

  c.fillText(label, posX + offsetX, posY + offsetY);

  c.beginPath();
  c.strokeStyle = this.color;
  c.lineWidth = 1;
  c.moveTo(posX, posY);
  c.lineTo(posX, posY + 7);
  c.stroke();

  if (grid) {
    c.beginPath();
    c.strokeStyle = this.color;
    c.lineWidth = 1;
    c.moveTo(posX, posY);
    c.lineTo(posX, 0);
    c.stroke();
  }
};

Chart.prototype.drawYAxisText = function drawYAxisText(i, grid) {
  const c = this.chart;

  const posX = this.xPadding;
  const posY = this.getYAxisPos(i);

  c.fillStyle = this.textColor;
  c.fillText(i, posX - 10, posY);

  c.strokeStyle = this.gridColor;
  c.beginPath();
  c.strokeStyle = this.color;
  c.lineWidth = 1;
  c.moveTo(posX, posY);
  c.lineTo(posX - 7, posY);
  c.stroke();

  if (grid) {
    c.beginPath();
    c.strokeStyle = this.color;
    c.lineWidth = 1;
    c.moveTo(posX, posY);
    c.lineTo(this.canvas.offsetWidth, posY);
    c.stroke();
  }
};

Chart.prototype.drawAxises = function drawAxises(drawXMax, drawYMax, drawGridX, drawGridY) {
  const c = this.chart;

  c.lineWidth = 2;
  c.font = `${this.fontSize || 12}px "${this.fontFace || 'Arial'}"`;
  c.textAlign = 'center';
  c.fillStyle = INDEPENDECE;

  c.strokeStyle = this.gridColor;
  c.beginPath();
  c.moveTo(this.xPadding, 0);
  c.lineTo(this.xPadding, this.canvas.offsetHeight - this.yPadding);
  c.lineTo(this.canvas.offsetWidth, this.canvas.offsetHeight - this.yPadding);
  c.stroke();

  for(let i = this.xMin; i < this.xMax; i += this.xStep) {
    this.drawXAxisText(i, drawGridX);
  }

  if (drawXMax) this.drawXAxisText(this.xMax, drawGridX);

  c.textAlign = 'right';
  c.textBaseline = 'middle';

  let i;
  for (i = this.yMin; i < this.yMax; i += (this.yStep || 10)) {
    this.drawYAxisText(i, drawGridY);
  }
  this.drawYAxisText(i, drawGridY);

  if (drawYMax) this.drawYAxisText(this.yMax, drawGridY);
};

Chart.prototype.drawLines = function drawLines() {
  const c = this.chart;
  const color = this.color || this.colors[Math.floor(Math.random() * this.colors.length)];

  let posX;
  let posY;

  c.strokeStyle = color;
  c.lineWidth = 5;

  posX = this.getXPos(0);
  posY = this.getYPos(0);

  c.beginPath();
  c.moveTo(posX, posY);

  for (let i = 1; i < this.series.length; i += 1) {
    c.lineTo(this.getXPos(i), this.getYPos(i));
  }

  c.stroke();

  c.fillStyle = color;
  c.strokeStyle = '#fefefe';
  c.lineWidth = 1;

  for (let i = 0; i < this.series.length; i += 1) {
    posX = this.getXPos(i);
    posY = this.getYPos(i);

    c.beginPath();
    c.arc(posX, posY, 3, 0, 2 * Math.PI);
    c.fill();
    c.stroke();
  }
};

Chart.prototype.drawRangedBars = function drawRangedBars() {
  const c = this.chart;

  let posX;
  let posY;
  let barHeight;

  const barWidth = this.canvas.width / ((this.xMax - this.xMin) / this.xStep) - 2;

  const bars = [];
  const front = typeof this.highlightedRange[0] === 'number' ? this.highlightedRange[0] : this.series[0].x;
  const rear = typeof this.highlightedRange[1] === 'number' ? this.highlightedRange[1] : this.series[this.series.length - 1].x;

  for (let i = 0; i < this.series.length; i += 1) {
    posX = this.getXPos(i);
    posY = this.getYPos(i);
    barHeight = this.getBarHeight(i);

    bars.push({
      x: posX / 2,
      y: posY / 2,
      w: barWidth / 2,
      h: barHeight / 2,
      hovering: false
    });

    if (
      (this.series[i].x >= front)
      && (this.series[i].x <= rear)
    ) {
      c.fillStyle = this.color;
    } else {
      c.fillStyle = this.grayColor;
    }

    roundRect(c, posX, posY, barWidth, barHeight, [4, 4, 0, 0]);
  }

  const { canvas, onBarMouseOver, onBarMouseOut } = this;

  if (
    (onBarMouseOver && (typeof onBarMouseOver === 'function'))
    || (onBarMouseOut && (typeof onBarMouseOut === 'function'))
  ) {
    canvas.onmouseover = () => {
      const viewportOffset = canvas.getBoundingClientRect();
      const { top: cy, left: cx } = viewportOffset;
      canvas.onmousemove = (e) => {
        const { clientX: px, clientY: py } = e;
        bars.forEach((bar, i) => {
          const { x, y, w, h } = bar;
          const bx = x + cx;
          const by = y + cy;

          if (
            (px >= bx)
            && (px <= bx + w)
            && (py >= by)
            && (py <= by + h)
          ) {
            if (!bars[i].hovering) {
              bars[i].hovering = true;

              if ((this.series[i].x >= front) && (this.series[i].x <= rear)) {
                bars[i].highlighted = true;
              } else {
                bars[i].highlighted = false;
              }

              if ((onBarMouseOver && (typeof onBarMouseOver === 'function'))) {
                onBarMouseOver(this.series[i].x, i, bar);
              }
            }
          } else {
            if (bars[i].hovering) {
              bars[i].hovering = false;
            }
          }
        });
      };

      canvas.onmouseout = () => {
        canvas.onmousemove = null;

        bars.forEach((bar, i) => {
          bars[i].hovering = false;
        });

        if (onBarMouseOut && (typeof onBarMouseOut === 'function')) {
          onBarMouseOut(null);
        }
      };
    };
  }
};

Chart.prototype.drawStackedBars = function drawStackedBars() {
  const c = this.chart;

  let posX;
  let posY;
  let barHeight;

  const barWidth = this.canvas.width / this.series.length / 2;
  const offsetX = this.getXMidOffset();

  for (let i = 0; i < this.series.length; i += 1) {
    posX = this.getXPos(i) + offsetX;

    const stack = this.series[i].y;
    let stackY = 0;
    for (let j = 0; j < stack.length; j += 1) {
      posY = this.getYPos(i, j);
      barHeight = this.getBarHeight(i, j);
      c.fillStyle = this.colors[j];

      if (j < stack.length - 1) {
        c.fillRect(posX, posY, barWidth, barHeight);
      } else {
        roundRect(c, posX, posY - stackY, barWidth, barHeight, [8, 8, 0, 0]);
      }

      if (stack[j] > 0) {
        c.fillStyle = WHITE;
        c.textAlign = 'center';
        c.fillText(stack[j], posX + barWidth / 2, posY + barHeight / 2 + 2 - stackY);
      }

      stackY += barHeight;
    }
  }
};

Chart.prototype.drawDonut = function drawDonut() {
  const c = this.chart;
  const cx = this.canvas.width / 2;
  const cy = this.canvas.height / 2;
  const r = (this.canvas.width - this.xPadding - this.yPadding) / 2;

  const sum = this.series.reduce((prev, i) => (prev + i), 0);

  c.textAlign = 'center';
  c.font = `${this.fontSize || 12}px "${this.fontFace || 'Arial'}"`;

  let stack = 0;
  for (let i = 0; i < this.series.length; i += 1) {
    c.fillStyle = this.colors[i];
    const s = (stack / sum) * 2 * Math.PI;
    const e = ((stack + this.series[i]) / sum) * 2 * Math.PI;

    fillArc(c, cx, cy, r, s, e);

    const t = ((stack + this.series[i] / 2) / sum) * 2 * Math.PI;
    const tx = cx + (r / 4) * 3 * Math.cos(t);
    const ty = cy + (r / 4) * 3 * Math.sin(t);

    c.fillStyle = WHITE;
    c.fillText(this.series[i], tx, ty);

    stack += this.series[i];
  }

  c.fillStyle = WHITE;
  fillArc(c, cx, cy, r / 2, 0, 2 * Math.PI);

  c.fillStyle = this.textColor;
  c.fillText(sum, cx, cy + 10);
};

Chart.prototype.clear = function clear() {
  this.chart.clearRect(0, 0, this.canvas.offsetWidth, this.canvas.offsetHeight);
  this.count = 0;
};

export default Chart;
